// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

/**
 * A request id the BFF can deserialize as a Guid.
 *
 * Most websocket messages carry `requestId` as a `Guid` on the BFF side, and System.Text.Json
 * rejects anything that is not UUID-shaped: the message is dropped with a warning and the client
 * never gets a reply. `crypto.randomUUID` is the obvious source and is used when present, but it
 * is missing on Hermes — so on the native apps the fallback is the normal path, not an edge case —
 * and on web served from a non-secure origin. The fallback is therefore a UUID v4-shaped string,
 * never a `prefix-timestamp-random` one.
 *
 * The Android e2e flows found this twice: TourInviteScreen's own fallback was
 * `tour-invite-<time>-<n>`, so no native guest could ever claim a temporary member, and the profile
 * screen's was `req_<time>_<random>`, so no native profile image was ever presigned — in both cases
 * the BFF logged "Failed to deserialize message of type …" and the app waited for a reply that
 * never came.
 */
export const createRequestId = (): string => {
  const uuid = (globalThis.crypto as { randomUUID?: () => string } | undefined)?.randomUUID?.();
  if (uuid) return uuid;
  const segment = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).slice(1);
  return `${segment()}${segment()}-${segment()}-4${segment().slice(1)}-a${segment().slice(1)}-${segment()}${segment()}${segment()}`;
};
